/** Travel Connect Datadog org is EU (`datadoghq.eu`). */
export const DEFAULT_DATADOG_SITE = "datadoghq.eu";

export function parseSampleRate(value: string | undefined, fallback: number): number {
  if (!value) return fallback;

  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return fallback;

  return Math.min(100, Math.max(0, parsed));
}

export function isEnvFlagEnabled(value: string | undefined, fallback: boolean): boolean {
  if (value === undefined || value === "") return fallback;
  if (value === "true") return true;
  if (value === "false") return false;
  return fallback;
}

export function getDatadogSite(explicit?: string): string {
  return explicit || DEFAULT_DATADOG_SITE;
}

/**
 * Unified service tagging uses `prod` / `stage` in this Datadog org.
 * Explicit `NEXT_PUBLIC_DATADOG_ENV` / `DD_ENV` wins; otherwise map Vercel.
 */
export function getDatadogEnv(input: {
  explicit?: string;
  vercelEnv?: string;
  gitRef?: string;
}): string {
  if (input.explicit) return input.explicit;
  if (input.vercelEnv === "production") return "prod";
  if (input.gitRef === "develop") return "stage";
  if (input.vercelEnv === "preview") return "preview";
  return "development";
}

export function getDatadogReleaseVersion(): string | undefined {
  return (
    process.env.NEXT_PUBLIC_DATADOG_VERSION ||
    process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA ||
    process.env.VERCEL_GIT_COMMIT_SHA
  );
}
